import { createContext } from 'maverick.js';

// src/player/ui/menu/radio/context.ts
var radioGroupContext = createContext();

export { radioGroupContext };
